const FALSE_VALUES = new Set(['false', '0', 'no']);

/**
 * Parse `data-dock-mode` from the embed script tag.
 * Truthy when the attribute is present and not explicitly disabled.
 */
export function parseDockModeEnabled(script: HTMLScriptElement | null): boolean {
  if (!script) return false;
  const value = script.dataset.dockMode;
  if (value === undefined) {
    return script.hasAttribute('data-dock-mode');
  }
  return !FALSE_VALUES.has(value.toLowerCase());
}

/** Dev preview / a11y harness fallback when no production script tag exists. */
export function resolveDockModeFromDevFallback(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env.VITE_WIDGET_DOCK_MODE === 'true') return true;
  const params = new URLSearchParams(window.location.search);
  const dockMode = params.get('dock-mode');
  return dockMode === '1' || dockMode === 'true';
}

/**
 * Resolve dock mode from the embed script, falling back to dev env / URL param.
 */
export function resolveDockModeEnabled(script: HTMLScriptElement | null): boolean {
  if (script) return parseDockModeEnabled(script);
  return resolveDockModeFromDevFallback();
}
